export var isSSR = function() {
    return "object" === "undefined";
};
export default isSSR;
